export default class SusilniStrojObj {
    ratings = [1.5, 2.0, 2.2, 3, 3.4, 3.9, 4.3, 4.8];

    strings_ratings = [
        "A+++",
        "A++",
        "A (od 2010 dalje)",
        "B (2007-2009)",
        "C (2007)",
        "D (pred 2007)",
        "E (pred 2007)",
        "F (pred 2007)"
    ];

    static curr_use;
    static new_use
    static savings;
    static curr_price;
    static new_price;

    ukrep1;
    ukrep1_savings;
    new_rating;

    ukrep2;
    ukrep2_savings;

    ukrep3;
    ukrep3_savings;

    ukrep4;
    ukrep4_savings;

    ukrep5;
    ukrep5_savings;

    constructor(rating, teden, vikend) {
        this.rating = rating;
        this.teden = teden;
        this.vikend = vikend;
        this.st_select = 5;
        this.short = "SS";
        this.st_ukrepov = 0;
        this.name = "Susilni stroj";

        this.my_rating = this.ratings[this.rating - 1];

        this.curr_use += (teden * this.my_rating);
        
        this.curr_use += (vikend * this.my_rating); // ceneje za vikende??

        this.detail_string = this.strings_ratings[this.rating - 1];
    }
}